module.exports = __webpack_public_path__ + "img/icon-invi.91284ac9.png";